<template>
  <div class="footer">
    <div class="part">
      <div class="part1">
        <div>
          <p>地址：</p>
          <div>{{list.address}}</div>
          <p>电话：</p>
          <div>{{list.tel}}</div>
        </div>
        <div>
          <p>QQ：</p>
          <div>{{list.qq}}</div>
          <p>邮箱：</p>
          <div>{{list.email}}</div>
        </div>
      </div>
      <div class="part2">
        <p>链接</p>
        <div v-for="(item, index) in link" :key="index">{{ item.linkurl }}</div>
      </div>
      <div class="part3">
        <p>版权所有</p>
        <div>{{list.desc}}</div>
        <div  @click="RecordNo()">ICP备案/许可证号：<div>{{list.beian}}</div></div>
      </div>
      <div class="part4">
        <img :src="ewm" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      list:[],
      ewm:'',
      link:''
    }
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.$axios({
        url: "/Index/footer",
        method: "GET",
        params: {
        },
      }).then((res) => {
        console.log("我可以获取到底部数据吗", res);
        this.list = res.data.data.footer;
        this.ewm='http://chengqifu.com'+this.list.ewm;
      });
      this.$axios({
        url: "Index/indexinfo",
        method: "GET",
        params: {},
      }).then((res) => {
        this.link = res.data.data.link;
      });
    },
    // 备案号
    RecordNo(){
      window.location.href="https://beian.miit.gov.cn/";
    }
  },
};
</script>
<style scope="scoped">
.footer {
  width: 100%;
  background: #333333;
  height: 400px;
  font-size: 21px;
  color: #fff;
}
.part {
  width: 1200px;
  margin: 0 auto;
  padding-top: 70px;
}
.part1 {
  width: 368px;
  margin-left: 30px;
  border-top: 1px solid;
  display: flex;
  float: left;
}
.part1 div {
  flex: 1;
  word-wrap: break-word;
  overflow: auto;
}
.part2 {
  font-size: 18px;
  width: 207px;
  margin-left: 30px;
  border-top: 1px solid;
  float: left;
  word-wrap: break-word;
  overflow: auto;
}
.part2 p {
  padding-top: 10px;
}
.part3 {
  font-size: 18px;
  width: 220px;
  margin-left: 30px;
  float: left;
  word-wrap: break-word;
  overflow: auto;
}
.part4 {
  width: 200px;
  margin-left: 30px;
  float: left;
}
.part4 img {
  width: 200px;
  height: 200px;
  object-fit: cover;
}
</style>


